import type { Container } from 'pixi.js';
import type { AnyModel, ModelType } from './types/models';
import { copyContainerProps } from './copyContainerProps';
import { setRelativePosition } from './setRelativePosition';
import { setInteractivitySounds } from './setInteractivitySounds';
import { getLayoutModuleByPath } from '../runtime/layoutModules';

type Module = Record<string, Record<string, unknown>>;

export const createInnerLayout = (
  model: AnyModel<ModelType.Layout>,
): { layout: object & { data?: unknown }; root: Container } | null => {
  const file = getLayoutModuleByPath(model.path) as Module | undefined;

  if (!file) {
    console.error(`Layout file not found for ${model.path}`);
    return null;
  }

  const layoutName = model.path.split('/').pop()?.slice(0, -3) || '';

  if (layoutName === '') {
    console.error(`Layout name is empty for ${model.path}`);
    return null;
  }

  const raw = file[layoutName].raw as { list: AnyModel<ModelType>[]; handleResize: boolean };
  const { handleResize } = raw;

  raw.handleResize = model.handleResize;

  // typed like this to be able to construct the layout module dynamically to extract the layout
  const layout = new (file[layoutName] as unknown as new () => Record<string, unknown>)();
  raw.handleResize = handleResize;

  if (!raw.list?.length) {
    console.error(`Layout ${layoutName} has empty list`);
    return null;
  }
  const rootView = layout[raw.list[0].name] as Container;
  copyContainerProps(rootView, model);
  setRelativePosition(rootView, model.percentX, model.percentY, model.x, model.y);
  setInteractivitySounds(rootView, model);

  return { layout, root: rootView };
};
